<template>
  <v-card>
    <v-card-title primary-title class="title">Sentiment</v-card-title>
    <v-card-text>
      <apexchart
        v-if="isMounted"
        type="pie"
        :options="options"
        :series="series"
        :height="320"
      ></apexchart>
    </v-card-text>
  </v-card>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
  components: {
    apexchart
  },
  props: {
    positiveCount: {
      type: Number,
      default: 0
    },
    negativeCount: {
      type: Number,
      default: 0
    },
    neutralCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isMounted: false,
      options: {
        colors: ['#1e9753', '#f2b344', '#3e8df3'],
        labels: ['Positive', 'Negative', 'Neutral'],
        legend: {
          position: 'bottom'
        }
      }
    }
  },
  computed: {
    series() {
      return [this.positiveCount, this.negativeCount, this.neutralCount]
    }
  },
  mounted() {
    this.isMounted = true
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/ReplyComment/Chart.vue